export const GET_GR_EVAL_FORM_GRID = '/api/gr/get-greval-forms-grid';
export const GET_GR_EVAL_FORM_DISTINCT = '/api/gr/get-greval-forms-grid/distinct';
export const DELETE_GR_EVAL_FORM = '/api/gr/delete-greval-form';
export const DELETE_GR_EVAL_PROJECT = '/api/gr/delete-greval-project';
export const GET_GR_EVAL_FORM = '/api/gr/get-greval-form';
export const SAVE_DRAFT_GR_EVAL_FORM = '/api/gr/save-draft-greval-form';
export const SAVE_GR_EVAL_FORM = '/api/gr/save-greval-form';
export const GET_GR_EVAL_PROJECT_SHORT_VIEW = '/api/gr/get-greval-project-short-detail';
export const EXPORT_GR_EVAL_PROJECT_REPORT = '/api/gr/export-greval-projects';
export const GENERATE_GR_EVAL_FORM_PPT = '/api/gr/generate-greval-form-ppt';
export const BULK_UPLOAD_GR_EVAL_FORM = '/api/gr/bulk-upload-eval-form';
export const EXPORT_GR_EVAL_GRID = '/api/gr/export-greval-grid';